/**
 * Copyright (C) 2010-2026 Kazo Vision. (http://www.kazovision.com)
 * All rights reserved.
 */
import * as servers from './servers';
import axios from 'axios';
const request = axios.create({
    baseURL: '/api',
    timeout: 60000,
    headers: { 'Content-Type': 'application/json' }
});
request.interceptors.request.use((config) => {
    // const token = localStorage.getItem('access_token');
    // if (token) {
    // 	config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
});
request.interceptors.response.use((response) => {
    return response;
}, (error) => {
    var _a, _b, _c;
    const { response } = error;
    if ((response === null || response === void 0 ? void 0 : response.status) === 400) {
        // 返回统一的业务数据格式
        return Promise.resolve({
            code: ((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) || 400,
            message: (_b = response.data) === null || _b === void 0 ? void 0 : _b.message,
            data: response.data
        });
    }
    // if (response?.status === 401) {
    // 	// token失效,清除 token
    // 	localStorage.removeItem('access_token');
    // 	localStorage.removeItem('userInfo');
    // 	window.location.href = '/login';
    // }
    return Promise.reject({
        code: (response === null || response === void 0 ? void 0 : response.status) || 500,
        message: ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message) || error.message,
        data: response === null || response === void 0 ? void 0 : response.data
    });
});
export default Object.assign(Object.assign({}, servers), { request });
